import { Alert } from "react-native";

const sendWelcomeEmail = async (recipientEmail, companyName, password) => {
  const emailData = {
    personalizations: [
      {
        to: [{ email: recipientEmail }],
        subject: `Welcome to Our Platform, ${companyName}!`,
      },
    ],
    from: { email: "tanmaygharat957@gmail.com" }, // Your verified sender email
    content: [
      {
        type: "text/plain",
        value: `Hello ${companyName},

Welcome to our platform! We are excited to have you onboard.

Here are your account details:
- Company Name: ${companyName}
- Email: ${recipientEmail}
- Password: ${password}

Please keep this information secure. If you have any questions, feel free to contact us.

Best regards,
The Platform Team`,
      },
    ],
  };

  try {
    const response = await fetch("https://api.sendgrid.com/v3/mail/send", {
      method: "POST",
      headers: {
        Authorization: `Bearer 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`, // Your API key
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    });

    if (!response.ok) {
      const error = await response.json();
      console.error("Error sending email:", error);
      Alert.alert("Error", "Failed to send welcome email.");
    } else {
      console.log("Welcome email sent successfully!");
    }
  } catch (err) {
    console.error("Error:", err.message);
    Alert.alert("Error", "Failed to send welcome email.");
  }
};

export default sendWelcomeEmail;
